import 'moment-timezone';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { SplitButton } from 'primereact/splitbutton';
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { AiOutlinePlus } from "react-icons/ai";
import { Link, useNavigate } from 'react-router-dom';
import { getEndpointUrl, getTimestamp, BadgeStatus } from "../../Utils/Common";
import CreateUser from "./CreateUser";
import UpdateUser from "./UpdateUser";
import DeleteUser from "./DeleteUser";
import { FaTrashAlt } from 'react-icons/fa';
import DeleteUserMultiple from './DeleteUserMultiple';
import Moment from 'react-moment';

const TableUsers = () => {
    const [userLogin, setUserLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    const navigate = useNavigate();

    const inputRef = useRef();
    const timeout = useRef();

    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);

    const [selectAll, setSelectAll] = useState(false);
    const [selectedCustomers, setSelectedCustomers] = useState([]);
    const [customers, setCustomers] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 15,
        page: 0
    });

    const [toggledClearRows, setToggleClearRows] = useState(false);

    const [showUpdate, setShowUpdate] = useState(false);
    const [updateData, setUpdateData] = useState({});

    const [showDelete, setShowDelete] = useState(false);
    const [deleteData, setDeleteData] = useState({});

    const [showDeleteMultiple, setShowDeleteMultiple] = useState(false);

    const [modalCreate, setModalCreate] = useState(false);


    const isSelectable = (data) => data.id != 1;

    const isRowSelectable = (event) => (event.data ? isSelectable(event.data) : true);

    const loadLazyData = () => {
        setLoading(true);

        fetch(getEndpointUrl() + `/users?page=${lazyParams.page}&per_page=${lazyParams.rows}&query=${globalFilterValue}&v=${getTimestamp()}`, { //
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
                // pragma: 'no-cache',
            }),
        }).then(response => response.json()).then(json => {
            if (json.status === 'ok') {
                setTotalRecords(json.results.total);
                setCustomers(json.results.data);
            }
            setLoading(false);
        });
    }

    const onPage = (event) => {
        setLazyParams(event);
    }

    useEffect(() => {

        return () => loadLazyData();
    }, [lazyParams]);

    useEffect(() => {
        //Clear the previous timeout.
        clearTimeout(timeout.current);

        // If there is no search term, do not make API call
        if (!globalFilterValue.trim()) {
            loadLazyData()
            return
        }
        timeout.current = setTimeout(() => {
            loadLazyData();
        }, 600);
    }, [globalFilterValue]);

    const onGlobalFilterChange = (e) => {
        setLoading(true);
        lazyParams.page = 0;
        setTotalRecords(0);
        setCustomers([]);

        const value = e.target.value;

        setGlobalFilterValue(value);
    };

    const onSelectionChange = (event) => {
        const value = event.value;
        setSelectedCustomers(value);
        setSelectAll(value.length === totalRecords);
    }

    const roleTemplate = (row) => {
        return <BadgeStatus status={row.role} />;
    };

    const tglRegisterTemplate = (row) => {
        return <Moment format="DD/MM/YYYY - HH:mm A">{row.createdAt}</Moment>;
    };

    const statusTemplate = (row) => {
        return <BadgeStatus status={row.status} />;
    };

    const header = (
        <Row>
            <Col md={4} sm={12} className="my-2">
                <h5 className="me-auto fw-bold pt-2">Data Pengguna Sistem</h5>
            </Col>
            <Col md={5} sm={12} className="my-2">
                <div className="d-md-flex">
                    <div className="ms-auto">
                        {selectedCustomers?.length ?
                            <Button key="delete" onClick={(e) => {
                                setShowDeleteMultiple(true);
                                setToggleClearRows(!toggledClearRows);
                            }} variant="danger" className="me-3"><FaTrashAlt /> ({selectedCustomers.length}) Hapus yang terpilih</Button> : ''
                        }
                        <Link to={`#`} title="Input Pengguna Sistem" onClick={(e) => setModalCreate(true)} className="btn btn-success me-3"><AiOutlinePlus className="me-2" /> Input Data</Link>
                        <CreateUser onCallback={(e) => onCallback(e)} show={modalCreate} close={(e) => setModalCreate(false)} />
                    </div>
                </div>
            </Col>
            <Col md={3} sm={12} className="my-2">
                <div className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText ref={inputRef} className="p-inputtext-sm" onChange={onGlobalFilterChange} placeholder="Pencarian..." style={{ minWidth: '100%' }} />
                </div>
            </Col>
        </Row>
    );

    const kelolaBodyTemplate = (rowData) => {
        return <SplitButton size="small" label="Edit" icon="pi pi-pencil"
            disabled={rowData.id == 1 || rowData.id == userLogin.id}
            onClick={(e) => {
                setShowUpdate(true);
                setUpdateData(rowData);
            }}
            model={[
                {
                    label: 'Hapus',
                    icon: 'pi pi-trash',
                    disabled: rowData.id == 1 || rowData.id == userLogin.id,
                    command: () => {
                        setShowDelete(true);
                        setDeleteData(rowData);
                    }
                }
            ]} severity="secondary" text />
    };

    const onCallback = useCallback((e) => {
        loadLazyData();
    }, []);

    return (
        <Container className="mt-3">
            <DataTable
                value={customers}
                lazy
                size="small"
                responsiveLayout="scroll"
                dataKey="id"
                header={header}
                globalFilterFields={['judul', 'deskripsi']}
                emptyMessage="Tidak ada data yang ditemukan."
                paginator
                first={lazyParams.first}
                rows={15}
                totalRecords={totalRecords}
                onPage={onPage}
                loading={loading}
                selection={selectedCustomers}
                isDataSelectable={isRowSelectable}
                onSelectionChange={onSelectionChange}
                selectAll={selectAll}>
                <Column selectionMode="multiple" />
                <Column field="name" header="NAMA" />
                <Column field="username" header="USERNAME" />
                <Column field="role" header="HAK AKSES" body={roleTemplate} />
                <Column field="email" header="EMAIL" />
                <Column field="phone" header="NO HANDPHONE" />
                <Column field="createdAt" header="TGL REGISTER" body={tglRegisterTemplate} />
                <Column field="status" header="STATUS" body={statusTemplate} />
                <Column header="KELOLA" body={kelolaBodyTemplate} />
            </DataTable>
            <UpdateUser row={updateData} onCallback={(e) => onCallback(e)} show={showUpdate} close={() => setShowUpdate(false)} />
            <DeleteUser row={deleteData} onCallback={(e) => onCallback(e)} show={showDelete} close={() => setShowDelete(false)} />
            <DeleteUserMultiple dataDelete={selectedCustomers} onCallback={(e) => onCallback(e)} show={showDeleteMultiple} close={() => setShowDeleteMultiple(false)} />
        </Container>
    );
}

export default TableUsers;
